import { useEffect, useMemo, useState } from "react";
import MobileHeader from "../../../../layout/mobile-header";
import { useSettlement } from "../../hooks/use-settlement";
import {
  MobileSolutionFinancial,
  MobileSolutionFinancialText,
  MobileSolutionHeader,
  MobileSolutionWrapper,
} from "./style";
import ReportCalender from "../calender/report-calender";
import { SolutionPoint } from "../solution-table/solution-point";
import ManualPointPopup from "../manualPoint";
import MobileSolutionHistory from "./components/history";
import { Overlay } from "../../../../styles/popup";

const MobileSolution = ({
  hook,
}: {
  hook: ReturnType<typeof useSettlement>;
}) => {
  const {
    tournamentList,
    expenditure,
    date,
    setDate,
    data,
    // 데이터 호출
    getSettlementData,
  } = hook;
  const [income, setIncome] = useState(0);
  const [calenderOpen, setCalenderOpen] = useState<boolean>(false);
  const [isManualPoint, setIsManualPoint] = useState<boolean>(false);
  const [isHistory, setIsHistory] = useState<boolean>(false);
  const [historyType, setHistoryType] = useState<string>("");

  useEffect(() => {
    if (!data) return;
    const sum = data.income.cash + data.income.card + data.income.bankTransfer;
    setIncome(sum);
  }, [data]);

  const financial = useMemo(
    () => [
      {
        name: "매출",
        icon: "income",
        value: income,
      },
      {
        name: "지출",
        icon: "expenditure",
        value: expenditure,
      },
    ],
    [income, expenditure],
  );

  const handleHistoryOpen = (type: string) => {
    setIsHistory(true);
    setHistoryType(type);
  };

  if (isHistory) {
    return (
      <MobileSolutionHistory
        onClose={() => setIsHistory(false)}
        type={historyType}
        data={data}
        date={date}
      />
    );
  }
  return (
    <MobileSolutionWrapper>
      {isManualPoint && (
        <ManualPointPopup
          onClose={() => {
            setIsManualPoint(false);
            getSettlementData();
          }}
          transactionPoint={data?.transactionPoint || 0}
          weeklyTransactionPoint={data?.weeklyTransactionPoint || 0}
        />
      )}

      <MobileHeader title="모바일 셀러" />
      <MobileSolutionHeader>
        <div className="date" onClick={() => setCalenderOpen(true)}>
          {date}{" "}
          <img
            onClick={(e: any) => {
              e.stopPropagation();
              setCalenderOpen(!calenderOpen);
            }}
            src="/image-web/solution/arrow.svg"
            alt="icon"
          />
        </div>
        <ReportCalender
          dailyDate={date}
          setDailyDate={setDate}
          calenderOpen={calenderOpen}
          setCalenderOpen={setCalenderOpen}
          getData={getSettlementData}
          type={"dashboard"}
        />
        {financial.map((item, i) => (
          <MobileSolutionFinancial key={i}>
            <div className="icon">
              <img
                src={`/image-web/solution/${item.icon}.png`}
                alt={item.name}
              />
            </div>
            <MobileSolutionFinancialText>
              <div>{item.name}</div>
              <div className={`${i === 0 ? "purple" : "red"}`}>
                {item.value?.toLocaleString()}
                <span> 원</span>
              </div>
            </MobileSolutionFinancialText>
          </MobileSolutionFinancial>
        ))}
      </MobileSolutionHeader>
      <SolutionPoint
        title="매장 이용권"
        data={data}
        handleManualPoint={() => setIsManualPoint(true)}
        handleHistoryOpen={handleHistoryOpen}
        date={date}
        type="POINT"
      />
      <SolutionPoint
        title="크레딧"
        allList={tournamentList}
        data={data}
        handleHistoryOpen={handleHistoryOpen}
        date={date}
        type="SEED"
      />
      <SolutionPoint
        title="캐럿"
        allList={tournamentList}
        data={data}
        handleHistoryOpen={handleHistoryOpen}
        date={date}
        type="CARROT"
      />
      {(calenderOpen || isManualPoint) && <Overlay />}
    </MobileSolutionWrapper>
  );
};

export default MobileSolution;
